import React from "react";
import { Menu } from "antd";
import { DashboardOutlined, SettingOutlined } from "@ant-design/icons";
import { Link } from "@reach/router";

const SideMenu = () => {
  return (
    <Menu mode="inline" className="page__layout__sider__menu">
      <Menu.Item key="1" icon={<DashboardOutlined />}>
        <Link to="/">Dashboard</Link>
      </Menu.Item>
      <Menu.Item key="2" icon={<DashboardOutlined />}>
        <Link to="/reporting-dashboard">Reporting Dashboard</Link>
      </Menu.Item>
      <Menu.SubMenu icon={<SettingOutlined />} title='Configurations'>
        <Menu.Item key="3" icon={<SettingOutlined />}>
          <Link to="/card-set">CardSet</Link>
        </Menu.Item>
        <Menu.Item key="4" icon={<SettingOutlined />}>
          <Link to="/states">States</Link>
        </Menu.Item>
        <Menu.Item key="5" icon={<SettingOutlined />}>
          <Link to="/routing">Routing</Link>
        </Menu.Item>
        <Menu.Item key="6" icon={<SettingOutlined />}>
          <Link to="/participants">Participants</Link>
        </Menu.Item>
      </Menu.SubMenu>
    </Menu>
  );
};

export default SideMenu;
